/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaClasseDocumento } from '@models';

@Pipe({
    name: 'anagraficaClasseDocumento',
})
export class AnagraficaClasseDocumentoPipe implements PipeTransform {

    transform(value: number, items: AnagraficaClasseDocumento[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
